import { render, staticRenderFns } from "./IconSettingsSliders.vue?vue&type=template&id=ea29f85c&"
import script from "./IconSettingsSliders.vue?vue&type=script&lang=js&"
export * from "./IconSettingsSliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports